import { createFileRoute } from "@tanstack/react-router";
import AdminTermsPage from "@/pages/admin/terms";

export const Route = createFileRoute("/app/admin/terms")({
  component: AdminTermsPage,
});
